import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEstimate from './estimate.reducer';

export const selectEstimateState = createFeatureSelector<fromEstimate.EstimateState>(fromEstimate.estimateFeatureKey);
export const selectIsLoading = createSelector(selectEstimateState, (state) => state.isLoading);
export const selectError = createSelector(selectEstimateState, (state) => state.error as string);
export const selectEstimate = createSelector(selectEstimateState, (state) => state.estimate);
export const selectIsManualEstimate = createSelector(selectEstimateState, (state) => state?.manualEstimate);
export const selectFeatures = createSelector(selectEstimateState, (state) => state?.features);
